module.exports = __webpack_public_path__ + "static/karussel2-38b7176fda2d946ef119d48cabc7eaef.jpg";